module.exports = __webpack_public_path__ + "static/assets/4da1bbd754a061ed1261fa70eb3f7dbd.svg";